import rules from '@/views/account/constants/rules';
import i18n from '@/locales/i18n';
import { GASignUpFromError } from '@/views/account/ga/signUp';
import { GALoginFromError } from '@/views/account/ga/login';
import { GAPersonalChangePasswordFormError } from '@/views/account/ga/personalCenter';

const emailRule = rules.email;
const passwordRule = rules.password;
const nameRule = rules.name;

/**
 *
 * 整合表单错误埋点
 * @param {string} action 埋点action值
 */
const GAFormError = (action) => {
  switch (action) {
    case 'signUp':
      return GASignUpFromError;
    case 'login':
      return GALoginFromError;
    case 'change_password':
      return GAPersonalChangePasswordFormError;
    default:
      return console.log;
  }
};

//验证抛出的异常数组的第二位是为了给埋点信息添加状态，对提示信息无用，在App.less中特意添加样式隐藏了数组中第二个报错信息

const Validator = {
  /**
   *仅需要验证是否为填写的表单使用
   * @param {RuleObject} rule 验证规则 （可忽略）
   * @param {any} value 表单值
   */
  emptyValidator: async (rule, value) => {
    if (!value || (value && value.replace(/\s+/g, '') === '')) {
      GAFormError(rule.formName)(`${rule.field}_empty`);
      throw [new Error(i18n.t('common:formEmptyErrorTips')), 'empty'];
    }
    return true;
  },

  /**
   *email 基础验证
   * @param {RuleObject} rule 验证规则 （可忽略）
   * @param {any} value 表单值
   */
  emailValidator: async (rule, value) => {
    console.log("rule",rule,value)
    if (!value || (value && value.replace(/\s+/g, '') === '')) {
      GAFormError(rule.formName)(`${rule.field}_empty`);
      throw [new Error(i18n.t('common:formEmptyErrorTips')), 'empty'];
    } else if (!emailRule.test(value.replace(/(^\s*)|(\s*$)/g, ''))) {
      GAFormError(rule.formName)(`${rule.field}_format_error`);
      throw [new Error(i18n.t('common:emailFormatErrorTips')), 'formatError'];
    } else {
      return true;
    }
  },

  /**
   *email 判断是否前后两个email是否相等
   * @param {RuleObject} rule 验证规则 （可忽略）
   * @param {any} value 表单值
   * @param {string} email 需要对比的email值
   */
  emailSameValidator: async (rule, value, email) => {
    if (!value || (value && value.replace(/\s+/g, '') === '')) {
      GAFormError(rule.formName)(`${rule.field}_empty`);
      throw [new Error(i18n.t('common:formEmptyErrorTips')), 'empty'];
    } else if (
      value.replace(/(^\s*)|(\s*$)/g, '') !==
      email.replace(/(^\s*)|(\s*$)/g, '')
    ) {
      GAFormError(rule.formName)(`${rule.field}_different_error`);
      throw [new Error(i18n.t('common:emailDifferentTips')), 'formatError'];
    } else {
      return true;
    }
  },

  /**
   *password 基础验证
   * @param {RuleObject} rule 验证规则 （可忽略）
   * @param {any} value 表单值
   */
  passwordValidator: async (rule, value) => {
    if (!value || (value && value.replace(/\s+/g, '') === '')) {
      GAFormError(rule.formName)(`${rule.field}_empty`);
      throw [new Error(i18n.t('common:formEmptyErrorTips')), 'empty'];
    } else if (!passwordRule.test(value)) {
      GAFormError(rule.formName)(`${rule.field}_format_error`);
      throw [
        new Error(i18n.t('common:passwordFormatErrorTips')),
        'formatError',
      ];
    } else {
      return true;
    }
  },

  /**
   *password 判断是否前后两个email是否相等
   * @param {RuleObject} rule 验证规则 （可忽略）
   * @param {any} value 表单值
   * @param {string} password 需要对比的email值
   */
  passwordSameValidator: async (rule, value, password) => {
    if (!value || (value && value.replace(/\s+/g, '') === '')) {
      GAFormError(rule.formName)(`${rule.field}_empty`);
      throw [new Error(i18n.t('common:formEmptyErrorTips')), 'empty'];
    } else if (value !== password) {
      GAFormError(rule.formName)(`${rule.field}_different_error`);
      throw [new Error(i18n.t('common:passwordDifferentTips')), 'formatError'];
    } else {
      return true;
    }
  },

  /**
   *name 基础验证
   * @param {RuleObject} rule 验证规则 （可忽略）
   * @param {any} value 表单值
   */
  nameValidator: async (rule, value) => {
    if (!value || (value && value.replace(/\s+/g, '') === '')) {
      GAFormError(rule.formName)(`${rule.field}_empty`);
      throw [new Error(i18n.t('common:formEmptyErrorTips')), 'empty'];
    } else if (!nameRule.test(value)) {
      GAFormError(rule.formName)(`${rule.field}_format_error`);
      throw [new Error(i18n.t('common:nameFormatErrorTips')), 'formatError'];
    } else {
      return true;
    }
  },
};

export default Validator;
